if (typeof ManageMotion === 'undefined') {
  class ManageMotion extends HTMLElement {
    constructor() {
      super()

      this.pause = false
      this.button = this.querySelector('.js-manage-motion')
      this.pauseBlock = this.querySelector('.js-pause-motion')
      this.playBlock = this.querySelector('.js-play-motion')
      this.doAction = this.doAction.bind(this)
    }

    connectedCallback() {
      this._attachListeners()
    }

    disconnectedCallback() {
      this._removeListeners()
    }

    doAction() {
      if (this.pause) {
        window.IS_MOTION_PAUSED = false

        this.pauseBlock.classList.remove('hidden')
        this.playBlock.classList.add('hidden')
        this.pause = false
        document
          .querySelectorAll('.animate')
          ?.forEach((item) => item.classList.remove('noanimate'))
        document.querySelectorAll('.js-video-control')?.forEach((item) => {
          if (item.classList.value.includes('play')) {
            item.click()
          }
        })
        document
          .querySelectorAll('.js-video-play')
          ?.forEach((item) => item.click())

        document
          .querySelectorAll('button[name="previous"]')
          ?.forEach((item) => item.click())
      } else {
        window.IS_MOTION_PAUSED = true

        this.pauseBlock.classList.add('hidden')
        this.playBlock.classList.remove('hidden')
        this.pause = true
        document
          .querySelectorAll('.animate')
          ?.forEach((item) => item.classList.add('noanimate'))
        document.querySelectorAll('.js-video-control')?.forEach((item) => {
          if (item.classList.value.includes('pause')) {
            item.click()
          }
        })
        document
          .querySelectorAll('.js-video-pause')
          ?.forEach((item) => item.click())
        document
          .querySelectorAll('button[name="previous"]')
          ?.forEach((item) => item.click())
      }
    }

    _attachListeners() {
      this.button.addEventListener('click', this.doAction, false)
    }

    _removeListeners() {
      this.button.removeEventListener('click', this.doAction, false)
    }
  }

  if (customElements.get('manage-motion') === undefined) {
    customElements.define('manage-motion', ManageMotion)
  }
}
